import AllRoutes from "./routes/AllRoutes";
import "./assets/Css/Style.css";

function App() {
	return <AllRoutes />;
}

export default App;
